module.exports = __webpack_public_path__ + "img/uk.e5564902.svg";